import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubble6"><Path d="M8 3C4.68629 3 2 5.68629 2 9V21H16C19.3137 21 22 18.3137 22 15V9C22 5.68629 19.3137 3 16 3H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble6;
